import groq from "groq";
import metaFields from "./metaFields";
import { applyFrench } from "@lib/applyFrenchField";

const portableText = `${applyFrench(
  `portableText[] {
        ...,
        markDefs[] {
            ...,
            _type == "internalLink" => {
                "type": @->_type,
                "slug": @->slug,
                "handle": @->handle,
            },
        },
    }`,
  `portableText_fr.portableText[] {
        ...,
        markDefs[] {
            ...,
            _type == "internalLink" => {
                "type": @->_type,
                "slug": @->slug,
                "handle": @->handle,
            },
        },
    }`
)}`;

const page = (id) => groq`
    *[(_id == '${id}' || _id =='drafts.${id}') && _type =='page'] | order(_updatedAt desc) {
        ${metaFields}
        ...,
        "portableText": ${portableText}
    }[0]
`;

export default page;
